import React from 'react';
import GenderFilter from '../Filters/GenderFilter';

const HighSchoolFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        _this,
        filterInputs,
    } = props;

    const { filters = {} } = search;

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        handleFilterUpdate: _this.handleFilterUpdate,
    };

    return (
        <React.Fragment>
            <GenderFilter
                {...commonFilterProps}
                data-testid="search.high-schools.filter.gender"
            />
        </React.Fragment>
    );
};

export default HighSchoolFilters;
